import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { CountClientsDTO, ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetCountClientCommand extends IRequestCommand<
  IGetCliensResponse,
  ErrorDetails,
  IGetCountClientCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/clients/totalClients';
  public override setParameters(parameters: IGetCountClientCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
  }
}

export interface IGetCountClientCommandParameters extends ICommandParameters {
    carrierUserId: string;
}

export interface IGetCliensResponse
  extends ICommandResponse,
  CountClientsDTO {}
